import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_GROUPS } from '../get-groups';
import { deleteGroupAPI } from './api';

export function useDeleteGroup({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (groupId) => deleteGroupAPI(groupId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_GROUPS, tenantId]);
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'success',
              description: 'deleteGroupSuccess',
            },
          });
        }, 100);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'deleteGroupError',
            },
          });
        }, 100);
      },
    },
  );

  return {
    deleteGroup: mutate,
    deleteGroupAsync: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}
